import script from "./AccountPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountPage.vue?vue&type=script&setup=true&lang=ts"

import "./AccountPage.vue?vue&type=style&index=0&id=566d874e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-566d874e"]])

export default __exports__